import type { Patient, Reference } from '@medplum/fhirtypes'
import type { Participant } from '@seen/core/models/patients/participant'
import { getReferenceString } from '@seen/core/references'
import { useMemo } from 'react'
import { useParticipants } from '#src/hooks/useParticipants.ts'

export function useParticipantsFrom(refs: Reference<Patient>[]): Participant[] {
  const participantsList = useParticipants()

  return useMemo(() => {
    const relevantPartipantsSet = new Set(refs.map(getReferenceString))

    return participantsList.filter((p) =>
      relevantPartipantsSet.has(p.reference.reference)
    )
  }, [refs, participantsList])
}
